module.exports = __webpack_public_path__ + "img/kale.3ca1cc7.webp";